import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import extAxios from '../../services/extAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';
import { saveAs } from 'file-saver';

const state = {
    remitoId: 0, 

    remitoEstadoId: 0,
    remitoEstado: null,
    remitoEstadoNombre: null,
    fechaDespacho: '1900-01-01',
    fechaDespachoHabilitada: false,
    fechaEntregaEstimada: '1900-01-01',
    fechaEntregaEstimadaHabilitada: false,
    fechaEntrega: '1900-01-01',
    fechaEntregaHabilitada: false,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, remitoId) {
        state.remitoId = remitoId;

        state.remitoEstadoId = 0;
        state.remitoEstado = null;
        state.remitoEstadoNombre = null;
        state.fechaDespacho = moment(new Date()).format('YYYY-MM-DD');
        state.fechaDespachoHabilitada = false;
        state.fechaEntregaEstimada = moment(new Date()).format('YYYY-MM-DD');
        state.fechaEntregaEstimadaHabilitada = false;
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD');
        state.fechaEntregaHabilitada = false;
    },

    'SET_ESTADO' (state, estado) {
        state.remitoEstadoId = estado.remitoEstadoId;
        state.remitoEstado = estado.remitoEstado;
        state.remitoEstadoNombre = estado.remitoEstado? estado.remitoEstado.nombre.trim() : null;
        if (moment(estado.fechaDespacho).format('YYYY-MM-DD') == '1900-01-01') {
            state.fechaDespacho = moment(new Date()).format('YYYY-MM-DD');
            state.fechaDespachoHabilitada = false;
        } else {
            state.fechaDespacho = moment(estado.fechaDespacho).format('YYYY-MM-DD');
            state.fechaDespachoHabilitada = true;
        }
        if (moment(estado.fechaEntregaEstimada).format('YYYY-MM-DD') == '1900-01-01') {
            state.fechaEntregaEstimada = moment(new Date()).format('YYYY-MM-DD');
            state.fechaEntregaEstimadaHabilitada = false;
        } else {
            state.fechaEntregaEstimada = moment(estado.fechaEntregaEstimada).format('YYYY-MM-DD');
            state.fechaEntregaEstimadaHabilitada = true;
        }
        if (moment(estado.fechaEntrega).format('YYYY-MM-DD') == '1900-01-01') {
            state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD');
            state.fechaEntregaHabilitada = false;
        } else {
            state.fechaEntrega = moment(estado.fechaEntrega).format('YYYY-MM-DD');
            state.fechaEntregaHabilitada = true;
        }
    },
    'SET_REMITO_ESTADO'(state, remitoEstado) {
        state.remitoEstado = remitoEstado;
        if (remitoEstado) {
            state.remitoEstadoId = remitoEstado.id? remitoEstado.id : 0;
            state.remitoEstadoNombre = remitoEstado.nombre? remitoEstado.nombre.trim() : null;
        } else {
            state.remitoEstadoId = 0;
            state.remitoEstadoNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, remitoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', remitoId);

            apiAxios.get(`remitos/${remitoId}/estado`)
                .then(res => {
                    commit('SET_ESTADO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    setRemitoEstado: ({ commit }, remitoEstado) => {
        return new Promise((resolve, reject) => {
            commit('SET_REMITO_ESTADO', remitoEstado);
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    save ( {} ) {
        return new Promise((resolve, reject) => {
            let url = `remitos/${state.remitoId}/actualizar-estado`;

            let fechaDespacho =  '1900-01-01';
            if ((/true/i).test(state.fechaDespachoHabilitada)) {
                fechaDespacho =  moment(state.fechaDespacho).format('YYYY-MM-DD');
            }
            let fechaEntregaEstimada =  '1900-01-01';
            if ((/true/i).test(state.fechaEntregaEstimadaHabilitada)) {
                fechaEntregaEstimada =  moment(state.fechaEntregaEstimada).format('YYYY-MM-DD');
            }
            let fechaEntrega =  '1900-01-01';
            if ((/true/i).test(state.fechaEntregaHabilitada)) {
                fechaEntrega =  moment(state.fechaEntrega).format('YYYY-MM-DD');
            }

            let remitoActualizacion = {
                remitoEstadoId: state.remitoEstadoId,
                fechaDespacho: fechaDespacho,
                fechaEntregaEstimada: fechaEntregaEstimada,
                fechaEntrega: fechaEntrega,
            };

            // if (params.remitoId == 0) {
            //     url = 'remitos/actualizar-estado';

            //     if (params.remitos) {
            //         remitoActualizacion.remitos = params.remitos.map(remito => ({
            //             id: remito.remitoId
            //         }))
            //     }
            // }

            apiAxios.post(url, remitoActualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}